// @ts-ignore
import { Methods, ContractNames } from "@airdao/airdao-bond";
import axios from "axios";
import { BigNumber, ethers, utils } from 'ethers';
import { MarketType, Token } from '../../contexts/MarketsContext/provider.interface';
import { SDA } from '../../utils/constants';
import React from 'react';
import { getTokenByAddress } from '../../utils/getTokenByAddress';

export const purchaseBonds = async (contracts: any, data: any, tokenAddress: string) => {
  // If the token is native, we need to send the amount with purchase transaction
  // Otherwise, we need to approve spend of ERC20 token
  let optionalArgs = tokenAddress === ethers.constants.AddressZero ? { value: data.amount} : {};
  const fixedTeller = data.vestingType === 'Fixed-expiry' ? ContractNames.FixedExpiryTeller : ContractNames.FixedTermTeller;

  if (tokenAddress !== ethers.constants.AddressZero) {
    const tx = await Methods.ERC20Approve(
      tokenAddress,
      contracts.getContractByName(fixedTeller).address,
      data.amount,
      contracts.signerOrProvider,
    );
    await tx.wait();
  }

  return await Methods.bondTellerPurchase(
    contracts,
    fixedTeller,
    data.recipient,
    data.referrer,
    data.id,
    data.amount,
    data.minAmountOut,
    optionalArgs,
  );
};

export const getProtocolFee = () => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/fee/protocolFee`)
};

export const getTokenPriceForChart = (tokenAddress: string, dateFrom: number, dateTo: number) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/tokens-price?tokenAddress=${tokenAddress}&dateFrom=${dateFrom}&dateTo=${dateTo}`,);
};

export const getSDAPriceForChart = (marketId: string, dateFrom: number, dateTo: number) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/market-prices?marketId=${marketId}&dateFrom=${dateFrom}&dateTo=${dateTo}`,);
};

export const getMarketTxs = (marketId: string) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/transactions/all/market?marketId=${marketId}`);
}

export const getMarketData = (id: string) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/markets/${id}`);
}

export const willGet = (tokenAmount: string, bondMarketPrice:number) => {
  return utils.parseUnits(
    (+tokenAmount * bondMarketPrice).toFixed(6),
    18,
  );
};

export const calculatedWillGet = (marketData: MarketType, amount: number, protocolFee: number) => {
  const calculatedProtocolFee = (amount * protocolFee) / 100;
  const slippage = marketData.marketType === SDA ? +amount * 0.0001 : 0;
  return utils.parseUnits(
    ((+amount -calculatedProtocolFee - slippage) * marketData.bondMarketPrice)
      .toFixed(18)
      .toString(),
    18,
  );

}

export const calculateMax = (marketData: MarketType, bnBalance: BigNumber) => {
  const balance = ethers.utils.formatEther(bnBalance);
  const maxPayout = BigNumber.from(marketData.maxPayout);
  const availableAmount = BigNumber.from(marketData.capacity);

  let newAmount;

  if (bnBalance.gt(availableAmount) && maxPayout.gt(availableAmount)) {
    const wg = willGet('1', marketData.bondMarketPrice);
    const result = availableAmount.mul(BigNumber.from(10).pow(18)).div(wg);
    newAmount = `${
      Math.floor(+utils.formatUnits(result, 18) * 1000000) / 1000000
    }`;
  } else if (willGet(balance, marketData.bondMarketPrice).gt(maxPayout)) {
    const wg = willGet('1', marketData.bondMarketPrice);
    const result = maxPayout.mul(BigNumber.from(10).pow(18)).div(wg);
    newAmount = `${
      Math.floor(+utils.formatUnits(result, 18) * 1000000) / 1000000
    }`;
  } else {
    newAmount = balance;
  }
  return newAmount;
}

export const handleAmount = (
  e: React.ChangeEvent<HTMLInputElement>,
  handler: (value: string) => void,
  quoteAddress: string,
  tokens: Token[]
) => {
  const decimals = e.target.value.split('.')[1];

  if (
    /^\d*\.?\d*$/.test(e.target.value) &&
    e.target.value !== '.' &&
    e.target.value !== '00' &&
    (!decimals ||
      decimals.length <=
      (getTokenByAddress(quoteAddress, tokens)
        ?.displayPrecision || 0))
  ) {
    handler(e.target.value);
  }
};